import React from 'react';
import { SocialIcon } from 'react-social-icons';

import { Share } from '@agilytics/components';
import { useAnalytics } from '@agilytics/context/Analytics';

const { navigator, encodeURIComponent } = window;

const SHARE_URL_BASE = `https://agilytics.leanloop.co.uk/`;
const SHARE_URL = encodeURIComponent(SHARE_URL_BASE);
const SHARE_TITLE = encodeURIComponent(
  `Stop estimating and start forecasting. I'm using agilytics to generate data-driven forecasts for my Jira projects. Check it out!`
);
const nativeShareEnabled = 'share' in navigator && 'canShare' in navigator && navigator.canShare();

function nativeShare() {
  const shareDetails = {
    title: SHARE_TITLE,
    url: SHARE_URL,
  };

  if (nativeShareEnabled) {
    return Promise.reject('native share not supported or disabled');
  }

  return navigator.share(shareDetails);
}

export default function ShareContainer() {
  const { analytics } = useAnalytics();

  const ourTwitterHandle = 'agilyticsapp';
  const relatedTwitterHandles = 'agilyticsapp,rapportapp';

  const networks = [
    {
      network: 'reddit',
      url: `http://www.reddit.com/submit?url=${SHARE_URL}&title=${SHARE_TITLE}`,
    },
    {
      network: 'linkedin',
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${SHARE_URL}`,
    },
    {
      network: 'twitter',
      url: `https://twitter.com/intent/tweet?text=${SHARE_TITLE}&url=${SHARE_URL}&via=${ourTwitterHandle}&related=${relatedTwitterHandles}`,
    },
  ];

  const onClickShare = async () => {
    if (nativeShareEnabled) {
      analytics.track('clickSocialShareNative');
      try {
        await nativeShare();
        analytics.track('socialShareNativeSuccess');
      } catch (e) {
        analytics.track('socialShareNativeFailed', { reason: e.message });
      }
    } else {
      analytics.track('clickSocialShare');
    }
  };

  return (
    <Share onClickShare={onClickShare} nativeShareEnabled={nativeShareEnabled} shareUrl={SHARE_URL_BASE}>
      {networks.map(({ network, url }) => (
        <SocialIcon
          key={`social-${network}`}
          network={network}
          url={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ margin: 10 }}
        />
      ))}
    </Share>
  );
}
